import React, { Component, Fragment } from 'react';
import { Helmet } from 'react-helmet';
import styled from 'styled-components'
import Header from '../../components/Header/Header';
import Main from '../../components/Main/Main';
import Card from '../../components/Card/Card';
import Footer from '../../components/Footer/Footer';
import TermsList from '../../components/Lists/TermsList'
import NumberedList from '../../components/Lists/NumberedList'
import FlexboxList from '../../components/Lists/FlexboxList'
import Paragraph from '../../collections/Paragraph/Paragraph';
import { fontUbuntuLight } from '../../utilities/utilities';

// const TermsParagraph = styled.p`
//     color: #0d1b58;
//     font-size: 1.0625em;
//     font-family: fontUbuntuLight;
// `;

const TermsTitle = styled.h2`
    /* display: block; */
    color: ${props => props.textColor ? props.textColor : '#0d1b58'};
    font-size: 1.6625em;
    font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
    font-weight: ${ props => props.bold ? 700 : 500 };
`;

// const TermsSpan = styled.span`
//     display: block;
//     color: ${props => props.textColor ? props.textColor : '#0d1b58'};
//     font-size: 1.0625em;
//     font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
//     font-weight: ${ props => props.bold ? 700 : 500 };
// `;

const OrderedList = styled.ol`
    color: ${props => props.textColor ? props.textColor : '#0d1b58'};
    font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
    list-style-type: none;
    counter-reset: item;
    margin: 0;
    padding: 0;
    margin-top: 0.5rem;

    & > li {
        display: table;
        counter-increment: item;
        margin-bottom: 0.5rem;
        width: 100%
    }

    & > li:before {
        content: counters(item, ".") ". ";
        display: table-cell;
        padding-right: 0.6em;    
        width:12px;
    }
`

const Terms = styled.div`
    padding: 1rem;
`

// const OrderedListItem = styled.li`
//     color: ${props => props.textColor ? props.textColor : 'inherit'};
//     font-family: ${props => props.fontFamily ? props.fontFamily : fontUbuntuLight};
//     font-weight: ${ props => props.bold ? 700 : 500 };
//     & ol > li {
//         margin: 0;
//         margin-bottom: 0.5rem;
//     }

//     & ol > li:before {
//         content: counters(item, ".") " ";
//     }
// `;

// const TermsList = styled.ul`
//     list-style: none;
//     margin-top: 0.5rem;
// `;
// const TermsListItem = styled.li`
//     font-weight: ${ props => props.bold ? 700 : 500 };
//     margin-bottom:0.5rem;
// `;
//
//  const TermsHeading = styled.strong`

// `

const FlexBox = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 2rem;
`
// const FlexItem = styled.div`
//     flex: 1 1 auto;
//     text-align: ${ props => props.right ? 'right' : 'left' };
//     margin-bottom: 1rem;
// `

// const TermsTable = styled.table`
//     width: 100%;
//     border-collapse: collapse;
//     margin-top: 0.25rem;
// `
// const TermsTableCell = styled.td`
//     border: 1px solid ${props => props.borderColor ? props.borderColor : '#0d1b58'};
//     padding: 0.5rem;
// `

class TermsPage extends Component {

    constructor(props) {
      super(props);

    }

    render(){
        let terms = this.props.type ? this.props.appState.tcs[this.props.type] : this.props.appState.tcs[this.props.appState.type];
        let termsList = Object.keys(terms.lists).map((term, index) => {
            let result;
            if(terms.lists[term].type === "termslist"){
                result = <TermsList list={terms.lists[term]} appState={this.props.appState} />;
            }
            if(terms.lists[term].type === "orderedlist"){
                result = <NumberedList list={terms.lists[term]} appState={this.props.appState} />;
            }


            return result;
        });

        let FlexList = Object.keys(terms.lists).map((term, index) => {
            let result;
            if(terms.lists[term].type === "flexbox"){
                result = <FlexboxList list={terms.lists[term]} appState={this.props.appState} />;
            }

            return result;
        });


        return (
            <Fragment>

                <Helmet>
                    {/* this.props.appState.ui.terms.meta.title */}
                    <title>{terms.title}</title>
                    <meta name="description" content={`this.props.appState.ui.terms.meta.description`} />
                </Helmet>

                <Header header={this.props.appState.ui.header} url={this.props.url}/>
                <Main site={this.props.appState.ui.site} >
                    {/* this.props.appState.ui.terms.card.titleText */}
                    <Card card={this.props.appState.ui.terms.card} pageTitle = {terms.title}>
                        <Terms>
                            <TermsTitle fontFamily={this.props.appState.ui.terms.card.fontFamily} textColor={this.props.appState.ui.terms.card.titleTextColor}>{terms.termsTitle}</TermsTitle>

                            <Paragraph fontFamily={this.props.appState.ui.terms.card.fontFamily} textColor={this.props.appState.ui.terms.card.titleTextColor}>{terms.termsSubtitle}</Paragraph>
                            <Paragraph fontFamily={this.props.appState.ui.terms.card.fontFamily} textColor={this.props.appState.ui.terms.card.titleTextColor}>{terms.termsDescription}</Paragraph>

                            <OrderedList fontFamily={this.props.appState.ui.terms.card.fontFamily} textColor={this.props.appState.ui.terms.card.titleTextColor}>
                                {termsList}
                            </OrderedList>

                            <FlexBox>
                                {FlexList}
                            </FlexBox>
                        </Terms>
                    </Card>
                </Main>
                <Footer footer={this.props.appState.ui.footer} url={this.props.url} clientTerms={this.props.appState.ui.clientTerms}/>

            </Fragment>
        );
    }
}


export default TermsPage;


// WEBPACK FOOTER //
// ./src/containers/TermsPage/TermsPage.js